import React from 'react';
import SvgIcon from './SvgIcon';

const DefaultPermission = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M14.25 19.125H.75s0-2.625 3.525-3.3C7.8 15.15 7.5 14.475 7.5 13.875v-.75A5.325 5.325 0 016 10.5c-.938 0-1.5-1.125-1.5-2.25 0-.3 0-1.5.75-1.5-.6-2.4-.15-4.875 1.5-4.875 3.9-2.625 9.375-.563 7.5 4.875.75 0 .75 1.2.75 1.5 0 1.125-.563 2.25-1.5 2.25a5.288 5.288 0 01-1.5 2.625v.75a1.388 1.388 0 00.938 1.275c.824.375 2.962.675 3.562.975"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M18.75 19.5V21m-4.5-3.75h9v6h-9v-6zm2.25 0V13.5a2.25 2.25 0 014.5 0v3.75h-4.5z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

DefaultPermission.displayName = 'DefaultPermissionIcon';

export default DefaultPermission;
